import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useLocationCtx } from "@/context/LocationContext";
import { useData } from "@/context/DataContext";
import Layout from "@/components/Layout";
import CategoryChips from "@/components/CategoryChips";
import BusinessCard from "@/components/BusinessCard";
import { Spinner, EmptyState } from "@/components/States";
import { ChevronLeft } from "lucide-react";

export default function CategoryPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { loc } = useLocationCtx();
  const { getCategory } = useData();
  const cat = getCategory(slug);
  const CatIcon = cat.icon;
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = { category: slug };
    if (loc.state) params.state = loc.state;
    if (loc.city) params.city = loc.city;
    api
      .get("/businesses", { params })
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, [slug, loc.state, loc.city]);

  return (
    <Layout>
      <header className="sticky top-0 z-40 glass border-b border-black/5 px-5 pb-3 pt-5">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(-1)} data-testid="back-button" className="rounded-full bg-[#F3F0E6] p-2">
            <ChevronLeft size={20} />
          </button>
          <div className="flex items-center gap-2">
            <CatIcon size={22} style={{ color: cat.color }} strokeWidth={2.4} />
            <h1 className="font-display text-2xl font-black tracking-tight">{cat.label}</h1>
          </div>
        </div>
        <div className="mt-3">
          <CategoryChips active={slug} />
        </div>
      </header>

      {loading ? (
        <Spinner />
      ) : items.length === 0 ? (
        <EmptyState title="Sin negocios en esta categoría" subtitle="Prueba con otra categoría o ubicación." />
      ) : (
        <section className="flex flex-col gap-4 px-5 pt-4">
          {items.map((b, i) => (
            <BusinessCard key={b.id} business={b} index={i} />
          ))}
        </section>
      )}
    </Layout>
  );
}
